/**
 * ClientsModal — página completa de Clientes embebida en un Dialog.
 *
 * Se abre cuando un cliente no es encontrado en SmartGT.
 * Pre-carga el buscador con el nombre del cliente y permite buscar, editar o crear clientes.
 */

import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog"
import { AlertTriangleIcon } from "lucide-react"
import { ClientsTable } from "@/pages/clients/ClientsTable"

interface Props {
  open: boolean
  onClose: () => void
  defaultSearch?: string
}

export function ClientsModal({ open, onClose, defaultSearch = "" }: Props) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose() }}>
      <DialogContent className="max-w-5xl w-full max-h-[90vh] flex flex-col p-0 gap-0">
        <DialogHeader className="px-6 pt-5 pb-4 border-b shrink-0">
          <DialogTitle>Clientes</DialogTitle>
          {defaultSearch && (
            <div className="flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 dark:bg-amber-950/20 dark:border-amber-800 px-3 py-2 text-sm text-amber-800 dark:text-amber-300 mt-2">
              <AlertTriangleIcon className="size-4 shrink-0" />
              <span>
                El cliente{" "}
                <span className="font-semibold underline uppercase">{defaultSearch}</span>{" "}
                no está registrado. Buscá el cliente y editalo para agregar este código SGT, o creá uno nuevo.
              </span>
            </div>
          )}
        </DialogHeader>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          <ClientsTable defaultSearch={defaultSearch} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
